import { render, staticRenderFns } from "./viewReservitionList.vue?vue&type=template&id=57bfdd4a&scoped=true&"
import script from "./viewReservitionList.vue?vue&type=script&lang=js&"
export * from "./viewReservitionList.vue?vue&type=script&lang=js&"
import style0 from "./viewReservitionList.vue?vue&type=style&index=0&id=57bfdd4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bfdd4a",
  null
  
)

component.options.__file = "viewReservitionList.vue"
export default component.exports